import React, {FC, memo} from 'react'
import {NavLineContentsInterface} from '../../types'

const NavContent: FC<NavLineContentsInterface> = memo(({navContents}) => {

    return (
        <>
            {
                navContents.map(({id, children}, index) => (
                    <div className={`tab-pane fade show ${index === 0 ? 'active' : ''} `} id={`kt_${id}`} role="tabpanel" key={index}>
                        {children}
                    </div>
                ))
            }
        </>
    )
})

export {NavContent}